import React from 'react';
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Navigation from "_content/Navigation.js";
import ChartContainer from 'components/custom/landingPages/ChartAndFeatures.js';

import HeaderBase, {
  LogoLink as LogoLinkBase,
} from "components/headers/light.js";
import { SectionHeadingH2 } from "components/misc/Headings.js";

import { Container as ContainerBase, ContentWithVerticalPaddingSmall, Content2Xl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import logoImageSrc from "images/logo-light.svg";

const PrimaryBackgroundContainer = styled.div`
${tw`-mx-8 px-8 bg-primary-900 text-gray-100`}
  background-color: #1a1a1a;
  background-image:
    radial-gradient(circle at 60% 70%, rgba(15, 35, 55, 0.95) 0%, rgba(25, 45, 65, 0.90) 50%, rgba(10, 30, 50, 0) 100%, transparent 100%),
    radial-gradient(circle at 50% 50%, rgba(20, 40, 60, 0.95) 0%, transparent 100%);
`;
const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8`;
const LogoLink = tw(LogoLinkBase)`text-gray-100 -mt-4`;

const Container = tw(ContainerBase)`-mt-12`;
const Row = tw.div`flex items-center flex-col lg:flex-row`;
const Column = tw.div`lg:w-1/2`;
const TextColumn = tw.div`text-left lg:text-left -mt-1 lg:-mt-24`;
const IllustrationColumn = tw(Column)`mt-16 lg:mt-0 lg:ml-16 hidden md:block`;
const Heading = tw(SectionHeading)`max-w-3xl lg:max-w-4xl text-left leading-tight text-3xl`;
const Description = tw(SectionDescription)`mt-4 max-w-2xl text-gray-100 lg:text-base mx-auto lg:mx-0`;
const SubHeading = tw(
  SectionHeadingH2
)`font-extrabold text-left mb-4 text-2xl text-gray-300 text-left lg:text-center`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;

export default ({
  content
}) => {
  const logoLink = (
   <LogoLink to={(window?.location?.href || '').includes('/es') ? "/es/" : "/"}>
      <img src={logoImageSrc} alt="Gunbot logo" width="40px" height="40px" style={{ width: "40px", height: "40px" }} />
      Gunbot
    </LogoLink>
  );

  const heading = content.h1;
  const notification = content.notification;

  return (
    <PrimaryBackgroundContainer>
      <Content2Xl>
        <Header logoLink={logoLink} links={<Navigation />} />
        <Container>
          <ContentWithVerticalPaddingSmall style={{}}>
            <Row>
              <TextColumn>
                <Notification>{notification}</Notification>
                <Heading>{heading}</Heading>
                <Description>{content.paragraph1}</Description>
                <Description>{content.paragraph2}</Description>
              </TextColumn>
              <IllustrationColumn style={{ minWidth: '50%' }}>
                <ChartContainer style={{ width: '752px' }} content={content} />              </IllustrationColumn>
            </Row>
          </ContentWithVerticalPaddingSmall>
        </Container>
      </Content2Xl>
    </PrimaryBackgroundContainer>
  );
};
